"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typebox_1 = require("@sinclair/typebox");
exports.default = typebox_1.Type.Object({
    transferId: typebox_1.Type.Optional(typebox_1.Type.Number()),
    steps: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
        id: typebox_1.Type.Number(),
        actualTime: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()])),
        isDone: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        delayReason: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()]))
    })))
});
